/*
Copyright 2026 Element Creations Ltd.
SPDX-License-Identifier: AGPL-3.0-only OR LicenseRef-Element-Commercial
Please see LICENSE in the repository root for full details.
*/
import { MatrixError, type MatrixClient } from "matrix-js-sdk";

/** Use Matrix's password reauthentication; preserve the existing call/join sessions. */
export async function changeOwnPassword(
  client: MatrixClient,
  current: string,
  next: string,
): Promise<void> {
  const auth = {
    type: "m.login.password",
    identifier: { type: "m.id.user", user: client.getUserId()! },
    password: current,
  };
  try {
    await client.setPassword(auth, next, false);
  } catch (error) {
    if (
      !(error instanceof MatrixError) ||
      error.httpStatus !== 401 ||
      typeof error.data.session !== "string" ||
      !Array.isArray(error.data.flows) ||
      !error.data.flows.some(
        (flow: { stages?: string[] }) =>
          flow.stages?.length === 1 && flow.stages[0] === "m.login.password",
      )
    )
      throw error;
    await client.setPassword(
      { ...auth, session: error.data.session },
      next,
      false,
    );
  }
}
